/* eslint-disable react/no-danger */
import React from 'react'
import SectionCta from '@components/Button/button'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import { convertToSlug } from 'src/utils/IdGenerator'
import styles from './Video.module.scss'
import VideoPlayer from './VideoPlayer'
import TwoColumnVideoLayout from './TwoColumnVideoLayout'

const Video = ({ data }) => {
  const { isMobile } = data
  const videoHeader = data?.data?.attributes?.videoHeader
  const floaterCta = data?.data?.attributes?.videoCta

  const cheerio = global.cheerio

  // Extract the h2 content and headerTabName
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = videoHeader?.match(h2Regex)
  const h2Content = matches ? matches[1] : null
  const idContent = data?.data?.attributes?.headerTabName || h2Content

  const videoContentFull = data?.data?.attributes

  const getModifiedHtml = content => {
    const $ = cheerio.load(content, null, false)

    $('p').each((_index, element) => {
      const $p = $(element)
      if ($p.html().trim() === '&nbsp;') {
        $p.remove()
      }
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    return modifiedHTML
  }

  return (
    <ErrorBoundary data={data}>
      <div className={`${styles.videoContainer} white`} id={convertToSlug(idContent)}>
        <div className={styles.videoHeader} dangerouslySetInnerHTML={{ __html: getModifiedHtml(videoHeader) }} />

        {videoContentFull?.twoColumnVideoSectionContent && videoContentFull?.twoColumnVideoLayoutType ? (
          <TwoColumnVideoLayout isMobileDevice={isMobile} twoColumnvideoData={videoContentFull} />
        ) : (
          <VideoPlayer isMobile={isMobile} videoContentFull={videoContentFull} />
        )}

        <div className={styles.videoCta}>
          <div className={styles.videoButtonPara} dangerouslySetInnerHTML={{ __html: floaterCta?.sectionCTAPara }} />
          <SectionCta data={floaterCta} segmentEventCommonProperties={data?.segmentEventCommonProperties} />
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default Video
